//REGISTER
export const POST_FAKE_REGISTER = "/post-fake-register"

// CAMPUSVIRTUAL
export const GET_USERNAME_PASSWORD_LOGIN = "/api/authenticate/login_post"
export const GET_FROM_AUTHENTICATECONTROLLER = "/api/authenticate/login"

//LOGIN
export const POST_FAKE_LOGIN = "/post-fake-login"
export const POST_FAKE_JWT_LOGIN = "/post-jwt-login"
export const POST_FAKE_PASSWORD_FORGET = "/fake-forget-pwd"
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd"

export const SOCIAL_LOGIN = "/api/authenticate/login"

//PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile"
export const POST_EDIT_PROFILE = "/post-fake-profile"

// Alumnos
export const GET_LISTA_ALUMNOS = "/api/alumno"

// Alumnos
export const GET_LISTA_CREDENCIALES = "/api/credenciales"

// Campus
export const GET_LISTA_CAMPUS = "/api/campus"

// Caja
export const GET_ESTADO_CUENTA = "/api/estadocuenta"
export const GET_FROM_CAJACONTROLLER = "/api/caja"
export const POST_CAJACONTROLLER = "/api/caja"
export const DELETE_CAJACONTROLLER = "/api/caja"

export const GET_FROM_DASHBOARDCONTROLLER = "/api/dashboard"
export const POST_FROM_DASHBOARDCONTROLLER = "/api/dashboard"

export const GET_FROM_CREDENCIALESCONTROLLER = "/api/caja"
export const POST_CREDENCIALESCONTROLLER = "/api/caja"
export const GET_FROM_PERSONACONTROLLER = "/api2/persona"
export const PUT_FROM_PERSONACONTROLLER = "/api2/persona"
export const POST_FROM_PERSONACONTROLLER = "/api2/persona"
export const DELETE_FROM_PERSONACONTROLLER = "/api2/persona"
export const POST_FROM_PHOTOCONTROLLER = "/api/photo"
export const POST_TO_FILECONTROLLER = "/api/file2"

export const GET_FROM_CONTROLESCOLARCONTROLLER = "/api/controlescolar"
export const POST_TO_CONTROLESCOLARCONTROLLER = "/api/controlescolar"
export const PUT_TO_CONTROLESCOLARCONTROLLER = "/api/controlescolar"
export const DELETE_FROM_CONTROLESCOLARCONTROLLER = "/api/controlescolar"

export const GET_FROM_ALUMNOCONTROLLER = "/api2/alumno"
export const POST_TO_ALUMNOCONTROLLER = "/api2/alumno"
export const PUT_TO_ALUMNOCONTROLLER = "/api2/alumno"
export const DELETE_FROM_ALUMNOCONTROLLER = "/api2/alumno"

export const GET_FROM_CAMPUSVIRTUALCONTROLLER = "/api/campusvirtual"
export const POST_TO_CAMPUSVIRTUALCONTROLLER = "/api/campusvirtual"
export const PUT_TO_CAMPUSVIRTUALCONTROLLER = "/api/campusvirtual"
export const DELETE_FROM_CAMPUSVIRTUALCONTROLLER = "/api/campusvirtual"

export const GET_FROM_DOCUMENTOSCONTROLLER = "/api/documentos"
export const POST_TO_DOCUMENTOSCONTROLLER = "/api/documentos"
export const PUT_TO_DOCUMENTOSCONTROLLER = "/api/documentos"
export const DELETE_FROM_DOCUMENTOSCONTROLLER = "/api/documentos"

export const GET_FROM_CONTRIBUYENTESCONTROLLER = "/api/contribuyentes"
export const POST_TO_CONTRIBUYENTESCONTROLLER = "/api/contribuyentes"
export const PUT_TO_CONTRIBUYENTESCONTROLLER = "/api/contribuyentes"
export const DELETE_FROM_CONTRIBUYENTESCONTROLLER = "/api/contribuyentes"

export const GET_FROM_CARGOSCONTROLLER = "/api2/cargos"
export const POST_TO_CARGOSCONTROLLER = "/api2/cargos"
export const PUT_TO_CARGOSCONTROLLER = "/api2/cargos"
export const DELETE_FROM_CARGOSCONTROLLER = "/api2/cargos"

export const POST_TO_WHATSAPPCONTROLLER = "api/whatsapp/send-template"
